import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import LoginFullBg from "./component/login/login";
import Home from "./interfaces/Home/Home";
import ProtectedRoute from "./routes/ProtectedRoute";
import { BrandProvider } from "./context/brand-context";
import ProductsHeroAndGrid from "./component/Products/ProductGrid";
import LayoutWithHeader from "./layouts/LayoutWithHeader";
import { accountRoutes } from "./routes/accountRoutes";
import ProductDetailsPage from "./component/ProductDetails/ProductDetailsPage";
import CartPage from "./component/Cart/CartPage";
import { Provider } from "react-redux";
import store from "./context/store";
import CheckoutPage from "./component/Checkout/CheckoutPage";
import PublicLayout from "./layouts/PublicLayout";
import PublicHome from "./interfaces/Public/PublicHome";
export default function App() {
  return (
    <Provider store={store}>
    <BrandProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* ---------- PAGES PUBLIQUES (indexables par Google) ---------- */}
            <Route element={<PublicLayout />}>
              <Route path="/" element={<PublicHome />} />
            </Route>

            <Route path="/login" element={<LoginFullBg />} />

            {/* ---------- ESPACE CLIENT (protégé par login) ---------- */}
            <Route element={<ProtectedRoute />}>
              <Route element={<LayoutWithHeader />}>
                <Route path="/espace" element={<Home />} />
                <Route path="/produits" element={<ProductsHeroAndGrid />} />
                {accountRoutes}
                 <Route path="/produits/:id" element={<ProductDetailsPage />} />
                 <Route path="/pannier" element={<CartPage />} />
                 <Route path="/checkout" element={<CheckoutPage />} />
              </Route>
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </BrandProvider>
    </Provider>
  );
}
